import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
const stepVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const stepItem = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ProcessSection() {
  return <section className="px-4 py-20 md:py-28 bg-midnight-900/50" data-id="element-410">
      <div className="max-w-3xl mx-auto" data-id="element-411">
        {/* How It Works */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-412">
          <div className="border-t-2 border-rescue-gold/40 w-16 mb-6" aria-hidden="true" data-id="element-413" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-414">
            How It Works
          </h2>
        </motion.div>

        <motion.div variants={stepVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} className="relative" data-id="element-415">
          {/* Connecting line */}
          <div className="absolute left-[22px] top-[44px] bottom-[44px] w-px bg-gradient-to-b from-rescue-gold/30 via-rescue-gold/15 to-transparent hidden md:block" aria-hidden="true" data-id="element-416" />

          <div className="space-y-10" data-id="element-417">
            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-418">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-419">
                1
              </div>
              <div data-id="element-420">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-421">
                  The Bypass
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-422">
                  Use the guide to jump straight to the 100% free IRS-verified
                  portals (no credit card required).
                </p>
              </div>
            </motion.div>

            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-423">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-424">
                2
              </div>
              <div data-id="element-425">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-426">
                  The Sprint
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-427">
                  Follow the screen-by-screen checklist to enter your income and
                  deductions in under an hour.
                </p>
              </div>
            </motion.div>

            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-428">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-429">
                3
              </div>
              <div data-id="element-430">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-431">
                  The Submission
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-432">
                  Hit 'Submit' with the confidence that you are 100% compliant
                  and $0 poorer.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* The 7-Day Identity Shift */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mt-16" data-id="element-433">
          <div className="border-l-4 border-rescue-gold/50 pl-6 py-2" data-id="element-434">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-435">
              The 7-Day Identity Shift
            </h3>
            <p className="font-body text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-436">
              Seven days from now, your taxes will be a memory. Instead of a
              "Notice of Intent to Levy" in your mailbox, you'll have a
              confirmation number from the IRS and the{' '}
              <span className="text-rescue-green font-semibold" data-id="element-437">
                $120 you saved
              </span>{' '}
              still sitting in your bank account.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}